export class AnalyzeCSVRequest{
    public fileBase64!: string; //base64 encoded file content
    public fileName!: string; //name of the file
    public domainId?: string; //domain to analyze against
    public purpose?: string; //purpose of the analysis
    public requestorId!: number; //id of the user making the request
}